import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _SidebarItem;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Link } from '@instructure/ui-link';
import { jsx } from '@instructure/emotion';
import PositionSummary from '../PositionSummary';
import t from '@instructure/quiz-i18n/format-message';
import { RichContentRenderer } from '@instructure/quiz-rce';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { Flex, END_EDITING_TRIGGER_CLASSNAME, withStyleOverrides } from '@instructure/quiz-common';
import { Tooltip } from '@instructure/ui-tooltip';
import { AccessibleContent } from '@instructure/ui-a11y-content';
export var SidebarItem = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_SidebarItem = /*#__PURE__*/function (_Component) {
  function SidebarItem() {
    var _this2;
    _classCallCheck(this, SidebarItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, SidebarItem, [].concat(args));
    // ============
    //   ACTIONS
    // ============
    _defineProperty(_this2, "scrollToItem", function (e) {
      e.preventDefault(); // prevent default link navigation
      if (_this2.props.preventScrollToItem) {
        return;
      }
      // this can be a real scroll or a oqaat change
      // depending on whether is is oqaat or not
      _this2.props.scrollToItem(_this2.props.itemId);
      e.stopPropagation();
    });
    return _this2;
  }
  _inherits(SidebarItem, _Component);
  return _createClass(SidebarItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "getPointsText",
    value:
    // ============
    //   HELPERS
    // ============

    function getPointsText(points) {
      return t("{\n      points, plural,\n        one {# point}\n      other {# points}\n    }", {
        points: points
      });
    }

    // =============
    //   RENDERING
    // =============
  }, {
    key: "renderPosition",
    value: function renderPosition() {
      var _this$props = this.props,
        displayPosition = _this$props.displayPosition,
        position = _this$props.position,
        quizEntry = _this$props.quizEntry,
        sidebarOpen = _this$props.sidebarOpen;
      if (!sidebarOpen && quizEntry && quizEntry.sizeOfBank > 1) {
        return jsx(PositionSummary, {
          firstPosition: position,
          lastPosition: position + quizEntry.sizeOfBank - 1
        });
      }
      return jsx("span", {
        css: this.props.styles.displayNumber
      }, displayPosition);
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var _this$props2 = this.props,
        displayPosition = _this$props2.displayPosition,
        itemId = _this$props2.itemId,
        isAnswered = _this$props2.isAnswered;
      var content = !isAnswered && isAnswered !== null ? t('Navigate to question at position {displayPosition}, unanswered', {
        displayPosition: displayPosition
      }) : t('Navigate to question at position {displayPosition}', {
        displayPosition: displayPosition
      });
      return jsx(Tooltip, {
        renderTip: this.props.sidebarOpen ? '' : jsx("span", {
          "aria-hidden": "true"
        }, content),
        placement: "start",
        on: this.props.sidebarOpen ? [] : ['hover', 'focus']
      }, jsx(Link, {
        href: "#",
        size: "small",
        margin: "0 small",
        isWithinText: false,
        forceButtonRole: false,
        onClick: this.scrollToItem,
        "data-automation-item-id": itemId,
        "data-automation": "sdk-sidebar-item-button"
      }, jsx(AccessibleContent, {
        alt: content
      }, this.renderPosition())));
    }
  }, {
    key: "renderClosed",
    value: function renderClosed() {
      return jsx("div", {
        css: this.props.styles.sidebarItem,
        className: END_EDITING_TRIGGER_CLASSNAME
      }, this.renderButton());
    }
  }, {
    key: "renderOpen",
    value: function renderOpen() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        itemName = _this$props3.itemName,
        pointsPossible = _this$props3.pointsPossible,
        styles = _this$props3.styles;
      var parentDivClass = "sidebarIsOpen ".concat(END_EDITING_TRIGGER_CLASSNAME);
      return jsx("div", {
        className: parentDivClass,
        css: styles.sidebarItem
      }, jsx(Flex, {
        justifyItems: "space-between"
      }, jsx(Flex.Item, null, this.renderButton()), jsx(Flex.Item, {
        shouldGrow: true,
        shouldShrink: true,
        onClick: this.scrollToItem,
        tabIndex: "-1"
      }, jsx("div", {
        css: this.props.styles.mainText
      }, jsx("div", {
        css: this.props.styles.infoHeader
      }, jsx("div", {
        className: "interactionType",
        css: this.props.styles.interactionType
      }, itemName), jsx("div", {
        className: "pointsPossible",
        css: this.props.styles.pointsPossible
      }, this.getPointsText(pointsPossible || 0))), jsx("div", {
        css: this.props.styles.itemBody
      }, jsx(RichContentRenderer, {
        content: this.props.itemBody
      })))), jsx(Flex.Item, null, jsx("div", {
        css: this.props.styles.pinWrapper
      }, children))));
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.sidebarOpen ? this.renderOpen() : this.renderClosed();
    }
  }]);
}(Component), _defineProperty(_SidebarItem, "displayName", 'SidebarItem'), _defineProperty(_SidebarItem, "componentId", "Quizzes".concat(_SidebarItem.displayName)), _defineProperty(_SidebarItem, "propTypes", {
  // Passed in by Sidebar
  children: PropTypes.element,
  displayPosition: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  itemBody: PropTypes.string,
  itemName: PropTypes.string.isRequired,
  inStimulus: PropTypes.bool,
  isAnswered: PropTypes.bool,
  position: PropTypes.number.isRequired,
  pointsPossible: PropTypes.number.isRequired,
  preventScrollToItem: PropTypes.bool.isRequired,
  quizEntry: ImmutablePropTypes.record,
  // not used on Take
  sidebarOpen: PropTypes.bool.isRequired,
  // from connect
  scrollToItem: PropTypes.func.isRequired,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_SidebarItem, "defaultProps", {
  children: null,
  inStimulus: false,
  itemBody: '',
  quizEntry: null,
  isAnswered: null
}), _SidebarItem)) || _class);
export default SidebarItem;